import { chains } from '@endure/chains';
import { cn } from '@endure/ui';

import type { Token } from 'types';
import { getTokenDisplaySymbol } from 'utilities';

export interface TokenIconProps {
  token: Token;
  displayChain?: boolean;
  size?: 'md' | 'lg' | 'xl';
  className?: string;
}

export const TokenIcon: React.FC<TokenIconProps> = ({
  className,
  token,
  displayChain = false,
  size = 'md',
}) => {
  const chain = chains[token.chainId];
  const tokenDisplaySymbol = getTokenDisplaySymbol(token);

  return (
    <div
      className={cn(
        'relative flex items-center',
        displayChain && size === 'md' && 'size-8',
        displayChain && size === 'lg' && 'size-13',
        displayChain && size === 'xl' && 'size-16',
        !displayChain && size === 'md' && 'size-5',
        !displayChain && size === 'lg' && 'size-6',
        !displayChain && size === 'xl' && 'size-8',
        className,
      )}
    >
      <img src={token.iconSrc} alt={tokenDisplaySymbol} className="w-full rounded-full" />

      {displayChain && (
        <img
          src={chain.iconSrc}
          className="size-[37.5%] absolute bottom-0 right-0 rounded-full"
          alt={`${chain.name} chain`}
        />
      )}
    </div>
  );
};
